import React from 'react'

import DownloadIcon from '@mui/icons-material/Download'
import { Button, CircularProgress } from '@mui/material'

interface DownloadCsvButtonProps {
  onClick?: () => void
  isLoading?: boolean
  disabled?: boolean
}

function DownloadCsvButton({ onClick, isLoading, disabled }: DownloadCsvButtonProps) {
  return (
    <Button
      variant="contained"
      startIcon={isLoading ? <CircularProgress size={24} color="primary" /> : <DownloadIcon />}
      onClick={onClick}
      disabled={disabled}
    >
      CSV
    </Button>
  )
}

export default DownloadCsvButton
